export default __webpack_public_path__ + "static/media/flag-iran.33d5ed98.svg";